import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Currency } from '@core/pricing-types';
import { BillingPlanTier } from '@core/products-types';
import type { PaymentInterval } from '@core/subscription-types';
import { DividerComponent, BadgeComponent, PlanButtonComponent } from '@core/user-interface-legacy';

import { JobSlotsLimitMessageComponent } from '../../../job-slots-limit-message/job-slots-limit-message.component';
import { PlanPickerProductCtaLabelPipe } from '../../plan-picker-product-cta-label.pipe';
import { ProductStatus } from '../../plan-picker.types';
import type { Product, Products } from '../plan-picker-2024.types';
import { ViewMode } from '../plan-picker-2024.types';
import { PlanPicker2024ProductPriceComponent } from '../plan-picker-product-price/plan-picker-2024-product-price.component';

@Component({
  selector: 'rt-plan-picker-2024-products',
  templateUrl: './plan-picker-2024-products.component.html',
  styleUrls: ['./plan-picker-2024-products.component.less'],
  imports: [
    PlanPicker2024ProductPriceComponent,
    PlanButtonComponent,
    BadgeComponent,
    NgTemplateOutlet,
    JobSlotsLimitMessageComponent,
    DividerComponent,
    TranslatePipe,
    PlanPickerProductCtaLabelPipe,
  ],
})
export class PlanPicker2024ProductsComponent {
  protected readonly ProductStatus = ProductStatus;

  @Input() public viewMode: ViewMode = ViewMode.Default;
  @Input() public interval: PaymentInterval;
  @Input() public currency: Currency;
  @Input() public products: Products;
  @Input() public showTrialBadge = false;
  @Input() public showSlotsLimitMessage = false;
  @Input() public startPlanSlotsLimit: number;

  public chooseProduct = output<Product>();
  public cancelSubscription = output<void>();

  public BillingPlanTier = BillingPlanTier;
  public ViewMode = ViewMode;

  public isButtonDisabled(status: ProductStatus) {
    return status === ProductStatus.Owned || status === ProductStatus.ManualServiceOwned;
  }

  public showCancelSubscription(status: ProductStatus) {
    return status === ProductStatus.TierOwned || status === ProductStatus.Owned;
  }
}
